import { Pipe } from '../class/export';
import { history } from '../utils/export';
import { SELECT_TOOL_DRAWING_PIPE, BEGIN_DRAWING_PIPE, UPDATE_DRAWING_PIPE, END_DRAWING_PIPE, BEGIN_DRAGGING_PIPE, UPDATE_DRAGGING_PIPE, END_DRAGGING_PIPE, SELECT_PIPE } from '../constants';

export default function (state, action) {

  switch (action.type) {
    case SELECT_TOOL_DRAWING_PIPE:
      return Pipe.selectToolDrawingPipe(state, action.sceneComponentType).updatedState;

    case BEGIN_DRAWING_PIPE:
      state = state.merge({ sceneHistory: history.historyPush(state.sceneHistory, state.scene) });
      return Pipe.beginDrawingPipe(state, action.layerID, action.x, action.y).updatedState;

    case UPDATE_DRAWING_PIPE:
      return Pipe.updateDrawingPipe(state, action.x, action.y).updatedState;

    case END_DRAWING_PIPE:
      state = state.merge({ sceneHistory: history.historyPush(state.sceneHistory, state.scene) });
      return Pipe.endDrawingPipe(state, action.x, action.y).updatedState;

    case BEGIN_DRAGGING_PIPE:
      state = state.merge({ sceneHistory: history.historyPush(state.sceneHistory, state.scene) });
      return Pipe.beginDraggingPipe(state, action.layerID, action.pipeID, action.x, action.y).updatedState;

    case UPDATE_DRAGGING_PIPE:
      return Pipe.updateDraggingPipe(state, action.x, action.y).updatedState;

    case END_DRAGGING_PIPE:
      state = state.merge({ sceneHistory: history.historyPush(state.sceneHistory, state.scene) });
      return Pipe.endDraggingPipe(state, action.x, action.y).updatedState;

    case SELECT_PIPE:
      return Pipe.select(state, action.layerID, action.pipeID).updatedState;

    default:
      return state;
  }
}